var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDataLossPrevention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3070",
    "data-name": "Rectangle 3070",
    width: 24,
    height: 24,
    transform: "translate(1807 2013)",
    fill: "#003fb9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_data_loss_prevention",
    transform: "translate(-1807 -2013)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8911",
    "data-name": "Group 8911",
    transform: "translate(1808.299 2013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8908",
    "data-name": "Group 8908",
    transform: "translate(5.126 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8431",
    "data-name": "Path 8431",
    d: "M8.5,13.969c-2.616,0-4.808-.768-5.407-1.8a1.134,1.134,0,0,0-.167.569v1.7c0,1.31,2.5,2.373,5.573,2.373s5.576-1.063,5.576-2.373v-1.7a1.127,1.127,0,0,0-.169-.569C13.3,13.2,11.114,13.969,8.5,13.969Z",
    transform: "translate(-2.922 -6.372)",
    fill: "#003fb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8432",
    "data-name": "Path 8432",
    d: "M8.5,13.74c-2.616,0-4.808-.769-5.407-1.8a1.127,1.127,0,0,0-.167.567v1.7c0,1.31,2.5,2.373,5.573,2.373s5.576-1.062,5.576-2.373V12.5a1.117,1.117,0,0,0-.169-.567C13.3,12.971,11.114,13.74,8.5,13.74Zm5.424-8.7C13.809,6,11.428,6.77,8.5,6.77S3.182,6,3.073,5.042a1.126,1.126,0,0,0-.151.543v1.7c0,1.31,2.5,2.373,5.573,2.373s5.576-1.062,5.576-2.373v-1.7A1.131,1.131,0,0,0,13.919,5.042Z",
    transform: "translate(-2.922 -2.641)",
    fill: "#003fb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8433",
    "data-name": "Path 8433",
    d: "M8.651,3.591c3,0,5.433-.8,5.433-1.8S11.652,0,8.651,0,3.219.8,3.219,1.8,5.652,3.591,8.651,3.591Z",
    transform: "translate(-3.078)",
    fill: "#003fb9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8910",
    "data-name": "Group 8910",
    transform: "translate(0 6.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14605",
    "data-name": "Path 14605",
    d: "M67.649,52.407l-3.662-.031,0-2.787a2.4,2.4,0,0,1,.612-1.921l0,0a28.971,28.971,0,0,0,3-2.788.685.685,0,0,1,.936,0l0,0a.658.658,0,0,1,.006.92c-.565.64-1.171,1.181-1.8,1.81a.4.4,0,0,0,.572.572c.646-.646,1.266-1.2,1.846-1.859h0l.009-.011.3-.364h0a2.852,2.852,0,0,0,.682-1.863v0l-.018-4.38c-.006-1.849.764-2.188,1.34-1.834a.692.692,0,0,1,.366.531h0l.233,8.06a2.162,2.162,0,0,1-.653,1.616l-3.65,3.644a.4.4,0,0,0-.119.286Zm-4.943.768,6.334.054a.565.565,0,0,1,.556.568l-.012,1.219a.555.555,0,0,1-.562.55l-6.334-.054a.56.56,0,0,1-.556-.562l.012-1.219A.564.564,0,0,1,62.705,53.175ZM63.763,54.2a.46.46,0,1,0-.854.341.46.46,0,1,0,.854-.341Z",
    transform: "translate(-50.67 -37.746)",
    fill: "#003fb9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14606",
    "data-name": "Path 14606",
    d: "M31.068,52.371,27.4,52.4V52a.4.4,0,0,0-.119-.286l-3.645-3.645a2.141,2.141,0,0,1-.652-1.616l.227-8.059a.784.784,0,0,1,1.175-.532c.335.256.541.827.538,1.832l-.018,4.379a2.847,2.847,0,0,0,.674,1.863l.006.007.3.365.007.008h0c.579.657,1.2,1.212,1.838,1.857a.4.4,0,1,0,.575-.57c-.624-.63-1.23-1.171-1.8-1.811a.658.658,0,0,1,.006-.92l0,0a.684.684,0,0,1,.934,0,27.834,27.834,0,0,0,3,2.79h0a2.4,2.4,0,0,1,.612,1.921Zm1.281.8a.568.568,0,0,1,.562.556l.012,1.219a.564.564,0,0,1-.556.562l-6.334.054a.56.56,0,0,1-.568-.55l-.006-1.219a.56.56,0,0,1,.55-.568Zm-.2,1.028a.456.456,0,0,0-.6-.257.46.46,0,0,0-.257.6.46.46,0,0,0,.854-.341Z",
    transform: "translate(-22.984 -37.739)",
    fill: "#003fb9",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDataLossPrevention);
export default __webpack_public_path__ + "static/media/ic_data_loss_prevention.4bddf7cc31a95e9e1f8f44d481a03ddb.svg";
export { ForwardRef as ReactComponent };